<template>
  <div
    style="
      padding: 0 15px;
      padding-bottom: 15px;
      padding-top: 1px;
      background-color: #ffffff;
      color: black;
    "
    v-if="ss"
  >
    <div class="detail">
      <div>
        <div>
          <div class="detail-name">
            <div class="display-left">充值金额</div>
            <div style="line-height: 32px; text-align: center; width: 70%">
              {{ detail.prestoreMoney }}元
            </div>
          </div>
          <div class="detail-name">
            <div class="display-left">赠送金额</div>
            <div style="line-height: 32px; text-align: center; width: 70%">
              {{ detail.giveMoney }}元
            </div>
          </div>
          <div class="detail-name">
            <div class="display-left">一共到账</div>
            <div style="line-height: 32px; text-align: center; width: 70%">
              {{
                (
                  Number(detail.prestoreMoney) + Number(detail.giveMoney)
                ).toFixed(2)
              }}元
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="detail">
      <van-radio-group v-model="posType">
        <div>
          <div
            v-for="(item, index) in newPayList"
            :key="item.name"
            class="detail-names"
            :style="{
              border: index + 1 == newPayList.length ? '0' : '',
            }"
          >
            <div class="display-left">
              <img class="img" :src="item.imageUrl" alt="" />
              <span style="margin-left: 10px">{{ item.name }}</span>
              <div v-if="qqs == true" class="recommend">
                <div v-if="item.systemRecommend == 1" class="recommends">
                  推荐
                </div>
              </div>
              <div v-else class="recommend">
                <div v-if="item.appRecommend == 1" class="recommends">推荐</div>
              </div>
            </div>
            <van-radio class="display-right" :name="item.id"></van-radio>
          </div>
        </div>
      </van-radio-group>
    </div>
    <div style="width: 100%">
      <van-button
        @click="shows(posType)"
        size="normal"
        style="width: 100%; border-radius: 10px"
        type="info"
      >
        确认支付
      </van-button>
    </div>
  </div>
</template>

<script>
  import { getPayList, xiaoBaiYuanPay } from "@/api/newPay";
  import { Loading } from "element-ui";
  export default {
    name: "Banlance",
    props: ["detail"],
    data() {
      return {
        //测试
        ceshiShow: true,
        //支付环境
        enm: 1,
        //商户类型
        posType: 1,
        //新支付列表
        newPayList: [],
        //新支付商户
        newPayListItem: [],
        duration: 5000,
        // 初始值
        startVal: 0,
        //appID
        appId: "",
        //code
        code: "",
        fom: {},
        ss: true,
        card: "",
        show: false,
        value: "",
        showKeyboard: true,
        po: false,
        val: "",
        radio: "",
        zhifu: [],
        tongguan: [],
        qqs: "",
        imagerurl: "",
        showss: false,
        weixin: [],
        zhifubao: [],
        yinlian: [],
        leshua: [],
        ast: "",
        fuBei: [],
      };
    },
    created() {},
    async mounted() {
      await Loading.service().close();
      await this.is_weixn();
      await this.getPayList();
    },
    methods: {
      //获取新支付列表
      getPayList() {
        getPayList(this.enm).then((res) => {
          res.data.forEach((item) => {
            item.list.forEach((items) => {
              items.imgUrl = item.imageUrl;
            });
          });
          this.posType = res.data[0].id;
          this.newPayList = res.data;
        });
      },
      //拉起支付
      xiaoBaiYuanPay(val, val1, val2, val3, val4, val5, val6) {
        xiaoBaiYuanPay(val, val1, val2, val3, val4, val5, val6).then((res) => {
          if (res.status == true) {
            if (res.data.payType == 2) {
              window.location.href = res.data.body;
            } else if (res.data.payType == 3) {
              this.imagerurl = `/app/qrcode/qrcode?content=${res.data.body}`;
              this.showss = true;
            }
          } else {
            this.$toast(res.msg);
          }
        });
      },

      confirmss() {
        this.showss = false;
      },
      is_weixn() {
        var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          this.enm = 3;
          return (this.qqs = true);
        } else {
          this.enm = 2;
          return (this.qqs = false);
        }
      },
      weixinSDK(appid, timeStamp, package2, nonceStr, paySign, type) {
        function onBridgeReady() {
          window.WeixinJSBridge.invoke(
            "getBrandWCPayRequest",
            {
              appId: appid,
              timeStamp: timeStamp,
              nonceStr: nonceStr,
              package: package2,
              signType: type,
              paySign: paySign,
            },
            function (res) {
              if (res.err_msg == "get_brand_wcpay_request:ok") {
                // 使用以上方式判断前端返回,微信团队郑重提示：
                //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                alert("充值成功");
              } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
                alert("取消充值");
              } else if (res.err_msg == "get_brand_wcpay_request:fail") {
                alert("充值失败");
              }
              // if (res.err_msg == "get_brand_wcpay_request:ok") {
              //   // 使用以上方式判断前端返回,微信团队郑重提示：
              //   //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
              //   this.$notify({ type: "warning", message: `支付成功` });
              // } else {
              //   this.$toast({
              //     message: "管理员未设置支付",
              //   });
              // }
            }
          );
        }
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener(
              "WeixinJSBridgeReady",
              onBridgeReady,
              false
            );
          } else if (document.attachEvent) {
            document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
            document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
          }
        } else {
          onBridgeReady();
        }
      },
      wx(code, type, than) {
        function jumpLink() {
          //       window.location="https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + that.appId +
          //       "&redirect_uri=" + window.location.protocol + '//' + window.location.host +
          // "&response_type=code&scope=snsapi_userinfo&state=" + time + "#wechat_redirect";''
          const url = encodeURIComponent(
            window.location.protocol +
              "//" +
              window.location.host +
              "/weixinRedirectPay/" +
              localStorage.getItem("meall") +
              "/" +
              localStorage.getItem("meall1") +
              "/" +
              localStorage.getItem("meall2") +
              `?card=${localStorage.getItem("meCardNum")}&payId=${
                than.radio
              }&biaoShi=${than.detail.a}`
          );
          window.location.href =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
            than.appId +
            "&response_type=code&scope=snsapi_userinfo&redirect_uri=" +
            url;
        }
        getUserInfo();
        function getUserInfo() {
          if (code != null && code != undefined && code.trim() != "") {
            xiaoBaiYuanPay().then((res) => {
              if (res.status) {
                var obj = {};
                obj = res.data.body;
                console.log(obj);
                than.weixinSDK(
                  obj.appId,
                  obj.timeStamp,
                  obj.package,
                  obj.nonceStr,
                  obj.sign,
                  obj.signType
                );
              } else {
                than.$toast(res.msg);
              }
            });
          } else {
            if (type == 1) {
              jumpLink();
            }
          }
        }
      },
      isWeiXin() {
        undefined;
        var ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          undefined;
          return true;
        } else {
          undefined;
          return false;
        }
      },

      confirm() {
        localStorage.removeItem("meall");
        localStorage.setItem("meall", this.detail.id);
        localStorage.removeItem("meall1");
        localStorage.setItem("meall1", this.detail.prestoreMoney);
        localStorage.removeItem("meall2");
        localStorage.setItem("meall2", this.detail.giveMoney);
        this.newPayListItem.forEach((item) => {
          if (this.radio == item.id) {
            this.code = item.code;
            this.appId = item.appId;
          }
        });

        if (this.isWeiXin() == true && this.code == 0 && this.posType == 1) {
          this.wx(null, 1, this);
        } else {
          this.xiaoBaiYuanPay(
            this.detail.prestoreMoney,
            this.radio,
            "",
            "MWEB",
            "",
            "",
            ""
          );
        }
      },
      shows(val) {
        this.newPayList.forEach((item) => {
          if (item.id == val) {
            let obj = {
              id: this.detail.id,
              prestoreMoney: this.detail.prestoreMoney,
              giveMoney: this.detail.giveMoney,
              payRadio: item.list[0].id,
              newPayListItem: item.list,
              payType: this.posType,
              posType: this.posType,
            };
            this.$emit("payShow", obj);
            //商户列表
            // this.newPayListItem = item.list;
            //首选
            // this.radio = this.newPayListItem[0].id;
            //商户弹唱
            // this.show = true;
          }
        });
      },
      tishi() {
        if (this.po == true) {
          this.po = false;
        } else {
          this.po = true;
        }
      },
    },
    components: {},
    watch: {
      value(value) {
        if (value.length === 6) {
          this.showKeyboard = false;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .img {
    width: 22px;
    height: 22px;
    vertical-align: middle;
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 120px;
    height: 120px;
    background-color: #fff;
  }
  .recommend {
    display: flex;
    align-items: center;
    width: 27px;
  }
  .recommends {
    background: #ffca66;
    color: #ffffff;
    width: 27px;
    text-align: center;
    font-size: 9px;
    height: 15px;
    border-radius: 3px;
  }
  .display-left {
    display: flex;
    align-items: center;
    justify-self: left;
    width: 50%;
  }
  .display-right {
    display: flex;
    align-items: center;
    width: 45%;
    justify-content: flex-end;
    margin-right: 5%;
  }
  .content {
    display: flex;
    justify-content: space-between;
    width: 100%;
    background-color: white;
    padding: 10px;
    color: black;
    font-size: 16px;
    border-top: 1px solid rgba(#009fff, 0.2);
  }

  .detail {
    width: 100%;
    justify-content: space-between;
    background: #f5f5f5;
    box-sizing: border-box;
    border-radius: 10px;
    margin: 15px 0;

    .detail-name {
      display: flex;
      align-content: center;
      font-size: 14px;
      padding: 10px;
      height: 30px;
      text-align: center;
      border-bottom: 1px solid rgba(128, 128, 128, 0.1);
    }

    .detail-names {
      display: flex;
      align-content: center;
      justify-content: space-between;
      font-size: 14px;
      height: 30px;
      padding: 10px;
      text-align: left;
      border-bottom: 1px solid rgba(128, 128, 128, 0.1);
    }
  }
</style>
